/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule }                from "@angular/core";
import { RouterModule, Routes }    from "@angular/router";
import { ThemeTurComponent }       from "./theme-tur.component";
import { TurMenuComponent }        from "./menu/tur-menu.component";
import { TurOptionsComponent }     from "./options/tur-options.component";
import { TurPayingComponent }      from "./paying/tur-paying.component";
import { TurCupComponent }         from "./cup/tur-cup.component";
import { TurServingComponent }     from "./serving/tur-serving.component";
import { TurServedComponent }      from './served/tur-served.component';
import { TurWarningComponent }     from './warning/tur-warning.component';
import { TurMaintenanceComponent } from "./maintenance/tur-maintenance.component";
import { TurUpdateComponent }      from "./update/tur-update.component";


const routes: Routes = [{
	path: '',
	component: ThemeTurComponent,
	children: [
		{
			path: 'menu',
			component: TurMenuComponent,
			data:  {animation: 'menu'}
		},
		{
			path: 'options',
			component: TurOptionsComponent,
			data:  {animation: 'options'}
		},
		{
			path: 'paying',
			component: TurPayingComponent,
			data:  {animation: 'paying'}
		},
		{
			path: 'cup',
			component: TurCupComponent,
			data:  {animation: 'cup'}
		},
		{
			path: 'serving',
			component: TurServingComponent,
			data:  {animation: 'serving'}
		},
		{
			path: 'served',
			component: TurServedComponent,
			data:  {animation: 'served'}
		},
		{
			path: 'warning',
			component: TurWarningComponent,
			data:  {animation: 'warning'}
		},
		{
			path: 'maintenance',
			component: TurMaintenanceComponent,
			data:  {animation: 'maintenance'}
		},
		{
			path: 'update',
			component: TurUpdateComponent,
			data:  {animation: 'update'}
		}
	]
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ThemeTurRoutingModule {

}
